import { actionTypes } from "./storeTypes";

export const init_local = {
  loading: true,
  storedValue: {
    rawdata: [],
    // currentTicker: "",
    // currentHorizon: "",
    filteredData: [],
  },
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_STOREDVALUE: {
      return {
        ...state,
        storedValue: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
